var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9003 0H8.0997C3.62636 0 0 3.62636 0 8.0997V26.9003C0 31.3736 3.62636 35 8.0997 35H26.9003C31.3736 35 35 31.3736 35 26.9003V8.0997C35 3.62636 31.3736 0 26.9003 0Z",
    fill: "url(#paint0_linear_304_340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7393 35V21.8078H24.1654L24.8297 16.6649H19.7393V13.3819C19.7393 11.8937 20.1509 10.8794 22.288 10.8794L25.0089 10.878V6.27829C24.5385 6.21739 22.9229 6.07669 21.0434 6.07669C17.1178 6.07669 14.4298 8.47279 14.4298 12.8723V16.6642H9.99036V21.8071H14.4298V34.9993H19.7393V35Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_304_340",
    x1: 17.5,
    y1: -0.0728,
    x2: 17.5,
    y2: 35.0448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005FDD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/FB.4fc7f9aaf73e7936a0563f4dd06003e7.svg";
export { ForwardRef as ReactComponent };